import React, { createContext, useContext, useState } from 'react';

import { KioskLiveUsageData } from '../../../../../../__generated__/graphql';
import { RootState } from '../../../../../../redux/reducers';
import useGetReservationConfig from '../../../../../../hooks/useGetReservationConfig';
import { useSelector } from 'react-redux';

interface KioskLiveUsageContextProps {
  isQuickActionsModalOpen: boolean;
  openQuickActionsModal: (kioskLiveUsageData: KioskLiveUsageData) => void;
  closeQuickActionsModal: () => void;
  quickActionsLiveUsageData?: KioskLiveUsageData;
  featureFlag: {
    isLoading: boolean;
    isEnabled?: boolean | null;
  };
}

const KioskLiveUsageContext = createContext<KioskLiveUsageContextProps | undefined>(undefined);

export const KioskLiveUsageProvider: React.FC = ({ children }) => {
  const [isQuickActionsModalOpen, setIsQuickActionsModalOpen] = useState(false);
  const [quickActionsLiveUsageData, setQuickActionsLiveUsageData] = useState<
    KioskLiveUsageData | undefined
  >();

  const activeMembership = useSelector((state: RootState) => state.me.activeMembership);
  const { isLoadingReservationConfig, reservationConfig } = useGetReservationConfig({
    tenantId: activeMembership?.tenantId,
    locationId: activeMembership?.location?.id ?? '',
  });

  const openQuickActionsModal = (kioskData: KioskLiveUsageData): void => {
    setQuickActionsLiveUsageData(kioskData);
    setIsQuickActionsModalOpen(true);
  };
  const closeQuickActionsModal = (): void => setIsQuickActionsModalOpen(false);

  return (
    <KioskLiveUsageContext.Provider
      value={{
        isQuickActionsModalOpen,
        openQuickActionsModal,
        closeQuickActionsModal,
        quickActionsLiveUsageData,
        featureFlag: {
          isLoading: isLoadingReservationConfig,
          isEnabled: reservationConfig?.enableLiveUsageEvents,
        },
      }}
    >
      {children}
    </KioskLiveUsageContext.Provider>
  );
};

export const useKioskLiveUsageContext = (): KioskLiveUsageContextProps => {
  const context = useContext(KioskLiveUsageContext);

  if (!context) {
    throw new Error('useKioskLiveUsageContext must be used within a KioskLiveUsageProvider');
  }

  return context;
};
